export function scrollTo(elementId: string): void {
  const $element = window.document.getElementById(elementId);

  if ($element) $element.scrollIntoView({ behavior: "smooth" });
}
